module.exports = __webpack_public_path__ + "static/media/04.9187164b.jpg";